<script lang="ts">
    import CN from "classnames";
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    const handleOpenReview = () => {
        dispatch("openReview");
    };
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
    class={CN("gw-rv-item")}
    on:click={handleOpenReview}
    role="button"
    tabindex="-1"
>
    <div class="gw-rv-item__media-block">
        <slot name="media" />
    </div>

    <div class="gw-rv-item__content">
        <div class="gw-rv-item__username-block">
            <slot name="username" />
        </div>

        <div class="gw-rv-item__published">
            <slot name="published" />
        </div>

        <div class="gw-rv-item__header">
            <slot name="rating" />
            <slot name="date" />
        </div>
        <div class="gw-rv-item__body">
            <slot name="product-title" />
            <slot name="title" />

            <p class="gw-rv-item__review-text">
                <slot name="text" />
            </p>

            <div class="gw-rv-item__vote-block">
                <div class="gw-rv-item__vote">
                    <slot name="vote" />
                </div>
            </div>
        </div>

        <div class="gw-rv-item__footer">
            <slot name="footer" />
        </div>
    </div>
</div>

<style lang="postcss">
    .gw-rv-item {
        border: 1px solid #e4e7ec;
        box-sizing: border-box;
        border-radius: 2px;
        background-color: #fff;
        cursor: pointer;

        &:hover:not(:has(.gw-rv-item__vote:hover)):hover {
            background-color: #fafafa;
        }
        &:hover &__media-block {
            opacity: 0.9;
        }

        &__content {
            padding: 1em 0.75em 0.5em;
            transition: transform 0.1s;
        }

        &__header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 0.5em;
        }

        &__published {
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }

        &__username-block {
            margin-top: 0.75em;
            display: flex;
            flex-wrap: wrap;
            column-gap: 0.5em;
        }

        &__review-text {
            margin: 0.5em 0 0;
            padding: 0;
            font-size: 14px;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 4; /* number of lines to show */
            line-clamp: 4;
            -webkit-box-orient: vertical;
        }

        &__vote-block {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-top: 0.75em;
        }

        &__footer {
            margin-top: 0.75em;
        }
    }
</style>
